import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TopAppBar from '../../components/feature/TopAppBar';
import BottomTabBar from '../../components/feature/BottomTabBar';
import Button from '../../components/base/Button';

export default function Schedule() {
  const { t } = useTranslation();
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isOnline, setIsOnline] = useState(true);
  
  const shifts = [
    { id: 1, time: '11:00 - 14:00', status: 'available', slots: 3 },
    { id: 2, time: '14:00 - 18:00', status: 'booked', slots: 0 },
    { id: 3, time: '18:00 - 22:00', status: 'available', slots: 5 },
    { id: 4, time: '22:00 - 01:00', status: 'available', slots: 2 },
  ];
  
  const weekDays = [t('mon'), t('tue'), t('wed'), t('thu'), t('fri'), t('sat'), t('sun')];
  const today = new Date();
  const currentWeek = Array.from({ length: 7 }, (_, i) => {
    const date = new Date(today);
    date.setDate(today.getDate() - today.getDay() + i + 1);
    return date;
  });
  
  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      <TopAppBar title={t('scheduleAndAvailability')} />
      
      <div className="pt-14 px-4">
        <div className="bg-white rounded-2xl p-4 shadow-md mb-4 mt-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className={`w-3 h-3 rounded-full ${isOnline ? 'bg-green-500' : 'bg-gray-400'} animate-pulse`}></div>
              <div>
                <p className="text-sm font-bold text-gray-900">
                  {isOnline ? t('online') : t('offline')}
                </p>
                <p className="text-xs text-gray-600">
                  {isOnline ? t('receivingOrdersNow') : t('notReceivingOrders')}
                </p>
              </div>
            </div>
            <button
              onClick={() => setIsOnline(!isOnline)}
              className="relative w-14 h-8 rounded-full transition-colors"
              style={{ backgroundColor: isOnline ? '#10B981' : '#D1D5DB' }}
            >
              <div
                className={`absolute top-1 w-6 h-6 bg-white rounded-full shadow-md transition-transform ${
                  isOnline ? 'translate-x-7' : 'translate-x-1'
                }`}
              ></div>
            </button>
          </div>
        </div>
        
        <div className="bg-white rounded-2xl p-4 shadow-md mb-4">
          <h3 className="text-sm font-bold text-gray-900 mb-3">{t('selectDate')}</h3>
          <div className="grid grid-cols-7 gap-2">
            {currentWeek.map((date, index) => {
              const isSelected = date.toDateString() === selectedDate.toDateString();
              const isToday = date.toDateString() === today.toDateString();
              return (
                <button
                  key={index}
                  onClick={() => setSelectedDate(date)}
                  className={`flex flex-col items-center py-2 rounded-xl transition-all ${
                    isSelected
                      ? 'bg-[#E31837] text-white'
                      : isToday
                      ? 'bg-blue-50 text-blue-600'
                      : 'bg-gray-50 text-gray-700'
                  }`}
                >
                  <span className="text-xs font-semibold mb-1">{weekDays[index]}</span>
                  <span className="text-base font-bold">{date.getDate()}</span>
                </button>
              );
            })}
          </div>
        </div>
        
        <div className="mb-4">
          <h3 className="text-base font-bold text-gray-900 mb-3">
            {t('availableShifts')} - {selectedDate.toLocaleDateString('sv-SE', { day: 'numeric', month: 'long' })}
          </h3>
        </div>
        
        <div className="space-y-3 mb-6">
          {shifts.map((shift) => (
            <div
              key={shift.id}
              className={`bg-white rounded-2xl p-4 shadow-md border-2 ${
                shift.status === 'booked' ? 'border-green-500' : 'border-gray-100'
              }`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                    shift.status === 'booked' ? 'bg-green-100' : 'bg-gray-100'
                  }`}>
                    <i className={`ri-time-line text-lg ${
                      shift.status === 'booked' ? 'text-green-600' : 'text-gray-600'
                    }`}></i>
                  </div>
                  <div>
                    <p className="text-base font-bold text-gray-900">{shift.time}</p>
                    <p className="text-xs text-gray-600">
                      {shift.status === 'booked' ? t('yourShift') : `${shift.slots} ${t('slotsLeft')}`}
                    </p>
                  </div>
                </div>
                {shift.status === 'booked' ? (
                  <div className="flex items-center gap-2 text-green-600">
                    <i className="ri-checkbox-circle-fill text-xl"></i>
                    <span className="text-sm font-semibold">{t('booked')}</span>
                  </div>
                ) : (
                  <Button variant="primary" size="small">
                    {t('book')}
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
        
        <div className="bg-blue-50 rounded-2xl p-4">
          <div className="flex items-start gap-3">
            <i className="ri-information-line text-lg text-blue-600 mt-0.5"></i>
            <div>
              <p className="text-sm text-blue-900 font-semibold mb-1">{t('flexibleWorkHours')}</p>
              <p className="text-xs text-blue-800 leading-relaxed">
                {t('flexibleWorkHoursDesc')}
              </p>
            </div>
          </div>
        </div>
      </div>
      
      <BottomTabBar />
    </div>
  );
}
